import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import HomePage from './components/HomePage';
import SearchPage from './pages/SearchPage';
import JobViewPage from './pages/JobViewPage';
import CompanyViewPage from './pages/CompanyViewPage';
import Footer from './components/Footer';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import CompaniesListPage from './pages/CompaniesListPage';
import { AppBar, Toolbar, Button, Box } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0052CC', // TBC-like blue color
    },
    secondary: {
      main: '#253858',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          <AppBar position="fixed" sx={{ backgroundColor: 'white' }}>
            <Toolbar>
              <Button
                component={Link}
                to="/"
                color="primary"
                sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}
              >
                JobsPortal
              </Button>
              <Box sx={{ flexGrow: 1 }} />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button
                  component={Link}
                  to="/jobs"
                  color="primary"
                >
                  Find Jobs
                </Button>
                <Button
                  component={Link}
                  to="/companies"
                  color="primary"
                >
                  Companies
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  component={Link}
                  to="/jobs"
                >
                  Post a Job
                </Button>
              </Box>
            </Toolbar>
          </AppBar>
          <Toolbar /> {/* This empty Toolbar acts as a spacer */}
          <main style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/jobs" element={<SearchPage />} />
              <Route path="/jobs/:id" element={<JobViewPage />} />
              <Route path="/companies" element={<CompaniesListPage />} />
              <Route path="/companies/:id" element={<CompanyViewPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App; 